import React, { useState, useEffect } from 'react';
import { Link } from 'react-router';
import { useDispatch } from 'react-redux';

import { deleteCoreBoardItem, getCoreBoardItems, addCoreBoardItem } from '../../../../redux/actions';
import GenericOverlayDialog from '../../../dialogs/genericOverlayDialog';

const CoreBoardItems = () => {
    const [coreBoardItems, setCoreBoardItems] = useState([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [tableError, setTableError] = useState('');
    const [showAddInputs, setShowAddInputs] = useState(false);
    const [newItems, setNewItems] = useState(['']);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        fetchCoreBoardItems();
    }, []);

    const fetchCoreBoardItems = () => {
        setTableLoading(true);
        setTableError('');
        dispatch(
            getCoreBoardItems('requestType=getAllReturnCoreBoards&appName=PNET', response => {
                if (response.status && Array.isArray(response.responseObject)) {
                    setCoreBoardItems(response.responseObject);
                } else {
                    setTableError('Failed to load core board items.');
                }
                setTableLoading(false);
            })
        );
    };

    const handleAddInput = () => {
        setNewItems([...newItems, '']);
    };

    const handleNewItemChange = (index, value) => {
        const updated = [...newItems];
        updated[index] = value;
        setNewItems(updated);
    };

    const handleRemoveNewItem = (index) => {
        const updated = newItems.filter((_, i) => i !== index);
        setNewItems(updated.length ? updated : ['']);
    };

  const handleSaveNewItems = () => {
    const validItems = newItems.map(i => i.trim()).filter(Boolean);
    if (!validItems.length) return;

    const promises = validItems.map(
        sku =>
            new Promise(resolve => {
                dispatch(
                    addCoreBoardItem({ sku }, response => {
                        resolve(response);
                    })
                );
            })
    );

    Promise.all(promises).then(() => {
        setShowAddInputs(false);
        setNewItems(['']);
        fetchCoreBoardItems();
    });
};

const handleDeletion = () => {
    setShowDeleteConfirmationDialog(false);
    dispatch(
        deleteCoreBoardItem(
            null,
            `requestType=deleteReturnCoreBoards&appName=PNET&itemNumber=${itemToDelete}`,
            response => {
                if (response.status) {
                    setItemToDelete(null);
                    fetchCoreBoardItems();
                }
            }
        )
    );
};

    const handleCancelAdd = () => {
        setShowAddInputs(false);
        setNewItems(['']);
    };

    const confirmDelete = (item) => {
        setItemToDelete(item);
        setShowDeleteConfirmationDialog(true);
    };

    return (
        <div className="nonGEASSOUser">
            <div className="push">
                <h1 className="pageTitle">Manage Core Board Items</h1>
            </div>

            {/* Header row: title + Add button */}
            <div className="flex justify-between align-center push">
                <h2 className="sectionTitle">Core Board Items</h2>
                <button
                    type="button"
                    onClick={() => setShowAddInputs(true)}
                    disabled={showAddInputs}
                >
                    + Add Core Board Items
                </button>
            </div>

            {/* Add new items panel */}
            {showAddInputs && (
                <div className="nonGEASSOUserForm col-12 col-sm-8 col-md-6 col-lg-5 push">
                    <h3>Add Core Board Items</h3>
                    {newItems.map((item, index) => (
                        <div key={index} className="nonGEASSOUserFormRow flex align-center" style={{ marginBottom: '8px' }}>
                            <input
                                type="text"
                                className="fullWidth"
                                placeholder="Enter core board item"
                                value={item}
                                onChange={e => handleNewItemChange(index, e.target.value)}
                            />
                            {newItems.length > 1 && (
                                <a
                                    href="javascript:void(0)"
                                    onClick={() => handleRemoveNewItem(index)}
                                    style={{textAlign: 'right' }}
                                >
                                    Delete
                                </a>
                            )}
                        </div>
                    ))}
                    <div className="flex" style={{ gap: '8px', marginBottom: '12px' }}>
                        <button type="button" onClick={handleAddInput}>
                            + Add More
                        </button>
                    </div>
                    <div className="flex justify-between">
                        <button type="button" className="orangeButton" onClick={handleCancelAdd}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={handleSaveNewItems}
                            disabled={!newItems.some(i => i.trim())}
                        >
                            Save
                        </button>
                    </div>
                </div>
            )}

          {/* Items table */}
            {tableLoading && <p>Loading items...</p>}
            {tableError && <p className="errorText">{tableError}</p>}
            {!tableLoading && !tableError && (
                <table className="coreBoardTable" style={{ borderCollapse: 'collapse', width: '100%' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ccc', padding: '5px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Sl. No.</th>
                            <th style={{ border: '1px solid #ccc', padding: '5px', textAlign: 'left', backgroundColor: '#f5f5f5' }}>Item Name</th>
                            <th style={{ border: '1px solid #ccc', padding: '8px 12px', textAlign: 'right', backgroundColor: '#f5f5f5' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {coreBoardItems.length > 0 ? (
                            coreBoardItems.map((item, index) => (
                                <tr key={item}>
                                    <td style={{ border: '1px solid #ccc', padding: '5px', textAlign: 'left' }}>{index + 1}</td>
                                    <td style={{ border: '1px solid #ccc', padding: '5px', textAlign: 'left' }}>{item}</td>
                                  <td style={{ border: '1px solid #ccc', padding: '8px 12px', textAlign: 'right' }}>
                                    <a
                                        href="javascript:void(0)"
                                        onClick={() => confirmDelete(item)}
                                    >
                                        Remove
                                    </a>
                                </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={3} style={{ border: '1px solid #ccc', padding: '8px 12px', textAlign: 'right' }}>No items found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            )}

            <p className="push">
                <Link to="/siteManagement">Back to Site Management</Link>
            </p>

            {showDeleteConfirmationDialog && (
                <GenericOverlayDialog
                    buttons={['no', 'yes']}
                    genericDialogHeading="Confirm"
                    genericDialogText={`Are you sure you want to remove "${itemToDelete}"?`}
                    flag="DeleteConfirmationDialog"
                    handleYes={handleDeletion}
                    handleDialog={() => setShowDeleteConfirmationDialog(false)}
                    showDialog={true}
                    defaultTop
                />
            )}
        </div>
    );
};

export default CoreBoardItems;


// WEBPACK FOOTER //
// ./src/App/components/PostLogin/SiteManagement/CoreBoardItems/index.js